import React from 'react';

import PhotoGalleryDetail from '../PhotoGallery/PhotoGalleryDetail/PhotoGalleryDetail';
import VideoDetail from '../Video/VideoDetail';
import { ResidenceViewDefaultProps, ResidenceViewPropTypes } from './ResidenceViewPropTypes';

const ResidenceView = ( { data } ) => ( ( data && data?.length > 0 )
  ? (
    <div id="view-scroll">

      { data.map( ( item ) => {
        const { type, data } = item;
        let component = null;
        switch ( type ) {
          case 'PhotoGallery':
            component = (
              <PhotoGalleryDetail
                key="viewGallery"
                id={null}
                uuid={null}
                images={data}
                galleryClass="slideshow"
                imageClass="slideshowPhoto"
              />
            );
            break;
          case 'Video':
            component = (
              <VideoDetail
                key={data?.videoId}
                hasId={false}
                videoId={data?.videoId}
                service={data?.service}
                autoplay={false}
              />
            );
            break;
          default:
        }
        return component;
      } )}

    </div>
  ) : null );

// The proptypes are failing for FloorPlanDetail right now and I don't know why.
// ResidenceView.propTypes = ResidenceViewPropTypes.data;
// ResidenceView.defaultProps = ResidenceViewDefaultProps.data;

export default ResidenceView;
